// extracted by mini-css-extract-plugin
export default {"menuToggle":"SelectV2_menuToggle__+g2Cu","placeholder":"SelectV2_placeholder__x1QoX"};